import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose, mapProps, nest, withState, withHandlers } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import Divider from 'components/fulcrum/divider/Divider'
import styles from './styles.scss'

import {
  fetchWeeklyUpdates,
  fetchRemainingWeeklyUpdates, 
  deleteWeeklyUpdate
} from './actions'

import { 
  weeklyUpdatesSelector, 
  weeklyUpdatesLoadingSelector,
  weeklyUpdatesRemainingLoadingSelector,
  weeklyUpdatesAlLFetchedSelector,
  totalCountSelector,
} from './selectors'

import {
  getWeekRange,
  getMonthDay,
  getMonthDateYearTime
} from 'helpers/DateUtil'

import FontIcon from 'react-toolbox/lib/font_icon';
import CardLoading from 'components/display/CardLoading'
import EntryItemRow from 'components/display/EntryItemRow'
import UpdateEntryMenu from './UpdateEntryMenu'

const INITIAL_NUMBER_OF_UPDATES_TO_LOAD = 4

const mapStateToProps = state => {
  return {
    weeklyUpdates: weeklyUpdatesSelector(state),
    isLoading: weeklyUpdatesLoadingSelector(state),
    isRemainingLoading: weeklyUpdatesRemainingLoadingSelector(state),
    allFetched: weeklyUpdatesAlLFetchedSelector(state),
    totalCount: totalCountSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchInitialWeeklyUpdates: (projectId)  => dispatch(fetchWeeklyUpdates(projectId, 0, INITIAL_NUMBER_OF_UPDATES_TO_LOAD)),
    fetchRemainingWeeklyUpdates: (projectId, startIndex) => dispatch(fetchRemainingWeeklyUpdates(projectId, startIndex, 1000)),
    deleteWeeklyUpdate: (id) => dispatch(deleteWeeklyUpdate(id))
  }
} 

class UpdateList extends Component {

  constructor(props){
    super(props)
    this.state = {
      showAllEntries: false
    }
  }

  componentDidMount(){
    const {id, fetchInitialWeeklyUpdates, toggleCollapse} = this.props
    fetchInitialWeeklyUpdates(id)
  }

  getPlaceholder(){
    return (
      <div styleName='placeholder'>No weekly updates to show</div>
    )
  }
  
  getDates(week, year){
    const range = getWeekRange(week, year)
    return getMonthDay(range.first) + ' - ' + getMonthDay(range.last)
  }

  getEntry(weeklyUpdate, last){
    const {
      workWeek,
      year,
      userName,
      role,
      text,
      id,
      createdAt
    } = weeklyUpdate

    const idText = `Week ${workWeek} (${this.getDates(workWeek, year)})`
    const subText = `${userName} | ${role} | ${getMonthDateYearTime(new Date(createdAt))}`
    const sideComponent = (<UpdateEntryMenu onDelete={() => this.props.deleteWeeklyUpdate(id)} />)
    
    return (
      <div key={id}>
        <EntryItemRow 
          idText={idText} 
          title={text} 
          subText={subText}
          sideComponent={sideComponent}
          />
        { !last && <Divider className={styles.divider}/> }
      </div>
    )
  }

  getInitialEntries(){
    const {
      weeklyUpdates
    } = this.props

    return weeklyUpdates.map((weeklyUpdate, index) => {
      if(index < INITIAL_NUMBER_OF_UPDATES_TO_LOAD){
        return this.getEntry(
          weeklyUpdate, 
          (index === weeklyUpdates.length - 1 || (!this.state.showAllEntries && index === INITIAL_NUMBER_OF_UPDATES_TO_LOAD - 1))
        )
      }
      return null
    })
  }

  getRemainingEntries(){
    const {
      weeklyUpdates
    } = this.props

    return weeklyUpdates.map((weeklyUpdate, index) => {
      if(index >= INITIAL_NUMBER_OF_UPDATES_TO_LOAD){
        return this.getEntry(weeklyUpdate, index === weeklyUpdates.length - 1)
      }
      return null
    })
  }

  expand(){
    const { 
      id, 
      allFetched, 
      fetchRemainingWeeklyUpdates,
      weeklyUpdates
    } = this.props
    
    if(!allFetched){
      fetchRemainingWeeklyUpdates(id, weeklyUpdates.length)
    }
    this.toggleShowAllEntries()
    
  }

  getExpandButton(){
    const {
      totalCount,
      weeklyUpdates
    } = this.props

    if(!this.state.showAllEntries && (
        weeklyUpdates.length > INITIAL_NUMBER_OF_UPDATES_TO_LOAD || 
        totalCount > INITIAL_NUMBER_OF_UPDATES_TO_LOAD ||
        weeklyUpdates.length < totalCount)){
      return (
        <div styleName='bottomButtonContainer' onClick={() => this.expand()}>
          <div styleName='bottomButtonContent'>
            <FontIcon value='expand_more' />
            Show more
          </div>
        </div>
      )
    }
    return null
  }

  getHideButton(){
    if(this.state.showAllEntries){
      return (
        <div styleName='bottomButtonContainer' onClick={() => this.toggleShowAllEntries()}>
          <div styleName='bottomButtonContent'>
            <FontIcon value='expand_less' />
            Show less
          </div>
        </div>
      )
    }
    return null
  }
  
  getHiddenEntries(){
    const {
      isRemainingLoading
    } = this.props
    if(this.state.showAllEntries){
      var content
      if(isRemainingLoading){
        content = (<CardLoading />)
      } else {
        content = this.getRemainingEntries()
      }
      return (
          <div>
            {content}
          </div>
      )
    }
    return null
  }

  toggleShowAllEntries(){
    this.setState({showAllEntries: !this.state.showAllEntries})
  }

  render(){
    const {
      isLoading,
      weeklyUpdates
    } = this.props

    if(isLoading){
      return (<CardLoading />)
    } else if(weeklyUpdates.length === 0){
      return this.getPlaceholder()
    }
    
    return (
      <div styleName='container'>
        {this.getInitialEntries()}
        {this.getExpandButton()}
        {this.getHiddenEntries()}
        {this.getHideButton()}
      </div>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)

const enhance = compose(
  withConnect,
  withStyle
)

export default enhance(UpdateList)
